export const services = [
  {
    id: "software-dev",
    name: "Software Development",
    to: "/SoftwareDevelopment",
    tagline: "Build reliable web and mobile products.",
    description:
      "From MVPs to enterprise-grade systems, we design and ship software that supports your growth and improves customer experience.",
    heroSrc: "Assets/website-concept.jpg",
    highlights: ["Web apps", "Mobile apps", "Cloud hosting", "Maintenance & support"],
  },
  {
    id: "bpr",
    name: "Business Process Re-engineering",
    to: "/BRP",
    tagline: "Reduce friction. Increase throughput.",
    description:
      "We redesign your workflows to unlock efficiency, improve transparency, and create scalable operating models.",
    heroSrc: "Assets/Consult.jpg",
    highlights: ["Process discovery", "Workflow redesign", "Change enablement", "Measurement & continuous improvement"],
  },
];

